import {Component, HostListener, Inject} from '@angular/core';
import {MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA, MatLegacyDialogRef as MatDialogRef} from '@angular/material/legacy-dialog';

import {
    SchoolYearRolloverModel,
    SchoolYearRolloverSettingsType,
    SchoolYearRolloverTableDatasourceModel
} from '@app/core/model/rollover-model';
import {Subject} from 'rxjs';
import {FormControl, UntypedFormBuilder, UntypedFormGroup} from '@angular/forms';

@Component({
    selector: 'ngc-school-year-rollover-settings-dialog',
    templateUrl: './school-year-rollover-settings-dialog.component.html',
    styleUrls: ['./school-year-rollover-settings-dialog.component.scss']
})
export class SchoolYearRolloverSettingsDialogComponent {

    overwriteCtrl = new FormControl(true, {nonNullable: true});
    onSave$ = new Subject<void>();
    formGroup: UntypedFormGroup = this.formBuilder.group({});
    dataRolloverSettings: SchoolYearRolloverModel[];
    selectedDataSourceDataToBeSet: SchoolYearRolloverTableDatasourceModel[];

    @HostListener('document:keydown.enter', ['$event'])
    onEnterKeydownHandler(event: KeyboardEvent) {
        this.onClickSave();
        event.preventDefault();
    }

    @HostListener('document:keydown.escape', ['$event'])
    onEscapeKeydownHandler(event: KeyboardEvent) {
        this.onClose();
    }

    constructor(private formBuilder: UntypedFormBuilder,
                public dialogRef: MatDialogRef<SchoolYearRolloverSettingsDialogComponent>,
                @Inject(MAT_DIALOG_DATA) public injectedData: SchoolYearRolloverTableDatasourceModel[]) {
        this.selectedDataSourceDataToBeSet = injectedData;
        this.dataRolloverSettings = [
            new SchoolYearRolloverModel(null, SchoolYearRolloverSettingsType.SuspendDataImport),
            new SchoolYearRolloverModel(null, SchoolYearRolloverSettingsType.DisableDataDeletion)
        ];
    }

    onClickSave() {
        this.onSave$.next();
    }

    onSaveDialog(dataRolloverSettings: SchoolYearRolloverModel[]) {
        dataRolloverSettings = dataRolloverSettings
            .filter((setting: SchoolYearRolloverModel) => setting.startDateTimestamp && setting.endDateTimestamp && setting.duration)
            .map((setting: SchoolYearRolloverModel) => {
                setting.overwrite = this.overwriteCtrl.value;
                return setting;
            });
        this.dialogRef.close(dataRolloverSettings);
    }

    onClose() {
        this.dialogRef.close();
    }
}
